/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sync_From_VisualInputs */

const cs_builder_sync_from_visual = /** @type {(inputs: Builder_Sync_From_VisualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizovat z vizuálu`)
};

const en_builder_sync_from_visual = /** @type {(inputs: Builder_Sync_From_VisualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync from visual`)
};

/**
* | output |
* | --- |
* | "Sync from visual" |
*
* @param {Builder_Sync_From_VisualInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sync_from_visual = /** @type {((inputs?: Builder_Sync_From_VisualInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sync_From_VisualInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sync_from_visual(inputs)
	return cs_builder_sync_from_visual(inputs)
});